import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronRight } from "@fortawesome/free-solid-svg-icons";

export default function BuildingBookTopRightTools(props) {

  var alertCount = typeof props.alertCount === "number" ? props.alertCount : 0;

  var onProcedures = props.onProcedures;
  var onAlerts = props.onAlerts;
  var onSearchPeople = props.onSearchPeople;
  var onSearchAssets = props.onSearchAssets;
  var onAbout = props.onAbout;

  var [open, setOpen] = useState(false);
  var wrapperRef = useRef(null);

  useEffect(function () {
    function handleClickOutside(e) {
      if (open && wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  const container = {
    position: "absolute",
    top: "14px",
    right: "14px",
    width: "400px",
    zIndex: 9
  };

  const launcher = {
    display: "flex",
    alignItems: "center",
    background: "#ffffff",
    borderRadius: "14px",
    boxShadow: "0 6px 16px rgba(0,0,0,0.12)",
    border: "1px solid #e7edf6",
    overflow: "hidden",
    cursor: "pointer"
  };

  const alertPill = {
    padding: "10px 14px",
    background: "linear-gradient(0deg, #b11226, #e11d48)",
    color: "#ffffff",
    fontWeight: 900,
    fontSize: "12px",
    borderTopLeftRadius: "14px",
    borderBottomLeftRadius: "14px",
    minWidth: "85px",
    textAlign: "center"
  };

  const toolsLabel = {
    flex: 1,
    padding: "10px 16px",
    fontWeight: 900,
    fontSize: "12px",
    color: "#111",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  };

  const dropdownWrapper = {
    maxHeight: open ? "300px" : "0px",
    opacity: open ? 1 : 0,
    overflow: "hidden",
    transition: "all 0.35s ease",
    background: "#ffffff",
    margin: "0 10px",                     // NARROWER THAN TOOLBAR
    borderRadius: "0 0 12px 12px",
    border: open ? "1px solid #e7edf6" : "none",
    borderTop: "none",
    boxShadow: open ? "0 16px 30px rgba(0,0,0,0.22)" : "none"
  };

  const linkRow = {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "14px 16px",
    cursor: "pointer",
    borderBottom: "1px solid #f0f0f0",
    transition: "background 0.2s ease"
  };

  const linkText = {
    fontSize: "13px",
    fontWeight: 600,
    color: "#222",
    flex: 1
  };

  const alertBadge = {
    background: "#e11d48",
    color: "#fff",
    fontSize: "11px",
    fontWeight: 800,
    borderRadius: "999px",
    padding: "2px 8px",
    marginRight: "8px"
  };

  return (
    <div style={container} ref={wrapperRef}>

      {/* Launcher */}
      <div style={launcher} onClick={() => setOpen(!open)}>
        <div style={alertPill}>
          {alertCount} Alert{alertCount !== 1 ? "s" : ""}
        </div>

        <div style={toolsLabel}>
          More Tools
          <FontAwesomeIcon
            icon={faChevronDown}
            style={{
              fontSize: "11px",
              color: "#777",
              transition: "transform 0.25s ease",
              transform: open ? "rotate(180deg)" : "rotate(0deg)"
            }}
          />
        </div>
      </div>

      {/* Dropdown */}
      <div style={dropdownWrapper}>
        {renderLink("Procedures", onProcedures)}
        {renderAlertsLink()}
        {renderLink("Search People", onSearchPeople)}
        {renderLink("Search Assets", onSearchAssets)}
        {renderLink("About the Building Book", onAbout, true)}
      </div>
    </div>
  );

  function renderAlertsLink() {
    return (
      <div
        style={linkRow}
        onClick={() => {
          setOpen(false);
          if (onAlerts) {
            onAlerts();
          }
        }}
        onMouseEnter={(e) => e.currentTarget.style.background = "#f9f9f9"}
        onMouseLeave={(e) => e.currentTarget.style.background = "#ffffff"}
      >
        <div style={linkText}>
          <span style={alertBadge}>{alertCount}</span>
          Alerts
        </div>
        <FontAwesomeIcon
          icon={faChevronRight}
          style={{ color: "#f4c400", fontSize: "13px" }}
        />
      </div>
    );
  }

  function renderLink(label, fn, isLast) {
    return (
      <div
        style={{
          ...linkRow,
          borderBottom: isLast ? "none" : linkRow.borderBottom
        }}
        onClick={() => {
          setOpen(false);
          if (fn) {
            fn();
          }
        }}
        onMouseEnter={(e) => e.currentTarget.style.background = "#f9f9f9"}
        onMouseLeave={(e) => e.currentTarget.style.background = "#ffffff"}
      >
        <div style={linkText}>{label}</div>
        <FontAwesomeIcon
          icon={faChevronRight}
          style={{ color: "#f4c400", fontSize: "13px" }}
        />
      </div>
    );
  }
}
